module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addCampaign":"Add a campaign","addProject":"add a project"},"fr":{"addCampaign":"Ajouter une campagne","addProject":"Ajouter un projet"},"de":{"addCampaign":"Kampagne hinzufügen","addProject":"Füge ein Projekt hinzu"}}')
  delete Component.options._Ctor
}
